module.exports = "pegasus_template/assets/circle-facebook.gif";